module.exports = __webpack_public_path__ + "img/homePageImg06.fa4c40a0.png";